export default {
    product: {
        description: {
            more: "více"
        },
        added: "Přidáno do košíku"
    }
}